<ngx-spinner
  [name]="name"
  bdColor="rgba(51,51,51,0.4)"
  class="spinner"
  color="#fff"
  size="large"
  type="ball-clip-rotate">
</ngx-spinner>
